<template>
  <div>
    <div class="content_header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/main?lang=' + lang }">{{
          cooperation.title
        }}</el-breadcrumb-item>
        <el-breadcrumb-item v-for="(item, index) in brandList" :key="index">{{
          item.categoryName
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 幻灯片图片 -->
    <div class="content_carousel">
      <el-carousel :interval="5000" arrow="always">
        <el-carousel-item v-for="item in banner" :key="item.id">
          <img :src="item.imageUrl" :alt="item.operationName" @click="handleView(item.redirectUrl)" class="carouselImg"
            :style="cursorPointer(item.redirectUrl)" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="content_notification">
      <ul class="list-with-divider">
        <li style="height: 30px; font-weight: bold;" class="el-icon-caret-right">
          {{ $t('notification.contentTitle') }}
        </li>
        <li v-for="notice in items" style="padding-left: 20px; height: 30px; cursor: pointer;"
          @click="handleStartNotice(notice, lang)">
          {{ notice.title }}
        </li>
      </ul>
    </div>

    <div>
      <el-row class="list-pagination" style="margin-right: 25px; margin-left: 25px">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
          :page-sizes="[20]" :page-size="20" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </el-row>
    </div>

  </div>
</template>

<script>
import { listBase, listNotification } from "@/api/sigen/techNotification";
import { switchLanguage } from "@/api/sigen/paginationLang";
import 'element-ui/lib/theme-chalk/index.css'

export default {
  inject: ['getCateId'],
  data() {
    return {
      activeName: ['1'],
      stepDescription1: '<p>富文本内容<strong>步骤一</strong><div @click="handleClick()">点击我</div></p> ',
      stepDescription2: '<p>富文本内容<strong>步骤二</strong>描述</p>',
      richButtonText: '<strong>加粗按钮</strong>',
      language: this.$i18n.locale,
      cooperation: '',
      breadFirst: '',
      breadSec: '',
      login: false,
      isLogin: 0,
      loginView: 0,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      noticeType: 0,
      lang: "en",
      bread: [],
      step: [],
      brandList: [],
      category: '',
      banner: [
        {
          id: 1,
          src: "https://www.sigenergy.com/static/0417/demo/sgp2install.webp",
          title: "xxx1",
          href: "detail/analysis"
        },
        {
          id: 2,
          src: "https://www.sigenergy.com/static/0417/demo/sgp2install.webp",
          title: "xxx2",
          href: "detail/count"
        },
        {
          id: 3,
          src: "https://www.sigenergy.com/static/0417/demo/sgp2install.webp",
          title: "xxx3",
          href: "detail/publish"
        },
        {
          id: 4,
          src: "https://www.sigenergy.com/static/0417/demo/sgp2install.webp",
          title: "xxx4",
          href: "detail/forecast"
        }
      ],
      items: []
    };
  },
  mounted() {
    // console.log(">>>>>>>>>>>>>>>>>>>>>>>>  mounted  getCateId :  ", this.getCateId())
  },
  created() {
    let lang = this.getRouteParams();
    this.handleSetLanguage(lang);
    // this.checkLogin();
    this.lang = lang;
    this.switchLanguage(this.lang);
    this.listStepPull(this.isLogin, lang, this.getCateId());
    this.listNotificationPull(
      this.loginView,
      lang,
      this.pageNum,
      this.pageSize
    )
  },
  computed: {
  },
  methods: {
    switchLanguage(lang) {
      switchLanguage(lang)
    },
    cursorPointer(redirectUrl) {
      if (redirectUrl === null || redirectUrl === '' || redirectUrl === undefined) {
        return '';
      }
      return 'cursor: pointer;';
    },
    handleChange(val) {
      console.log(val);
    },
    handleStartNotice(notice, lang) {
      // this.$router.push({
      //   name: "notice-details",
      //   query: { noticeId: notice.id, lang: lang }
      // });
      var url = 'notice-details?noticeId=' + notice.id + '&lang=' + lang;
      window.open(url, "_blank");
    },
    listStepPull(isLogin, lang, cateId) {
      if (lang === undefined) {
        return;
      }
      listBase(isLogin, lang, cateId)
        .then((res) => {
          this.cooperation = res.data.result.cooperation;
          this.brandList = res.data.result.brandList;
          this.banner = res.data.result.banner;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    handleView(linkUrl) {
      // file view
      window.open(linkUrl, "_blank");
    },
    getRouteParams() {
      // 使用 let phone=this.$route.query.name 来获Get请求参数的值
      let lang = this.$route.query.lang;
      return lang;
    },
    handleSetLanguage(lang) {
      this.$i18n.locale = lang;
      this.language = lang;
    },
    checkLogin() {
      if (this.userInfo.id !== undefined) {
        this.login = true;
        if (this.login) {
          this.isLogin = 0;
        } else {
          this.isLogin = 1;
        }
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      if (this.listLoading) {
        messageWarn(this, this.$t("load.loading"));
        return;
      }
      this.listNotificationPull();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      if (this.listLoading) {
        messageWarn(this, this.$t("load.loading"));
        return;
      }
      this.listNotificationPull();
    },
    listNotificationPull() {
      listNotification(
        this.loginView,
        this.lang,
        this.noticeType,
        this.pageNum,
        this.pageSize
      )
        .then((res) => {
          this.items = res.data.result.data;
          this.total = res.data.result.total;
          this.isLastPage = res.data.result.isLastPage;
          this.listLoading = false;
        })
        .catch((error) => {
          messageWarn(this, this.$t("load.noMoreData"));
          this.listLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.content_header {
  margin-left: 10px;
  line-height: 30px;
  margin-top: 20px;
}

.inline-div {
  display: inline;
  margin-right: 10px;
  /* 可以添加间距 */
}

.content_carousel {
  margin-left: 20px;
  margin-top: 17px;
  margin-right: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
  cursor: pointer;
}

.carouselImg {
  width: 100%;
  height: 100%;
  margin-right: 5px;
  border-radius: 4px;
}

/** 走马灯样式 */
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 260px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.content_notification {
  margin-left: 20px;
  margin-right: 30px;
  margin-top: 30px;
  font-size: 15px;
}

ul {
  list-style-type: none;
  /* 移除列表的标记 */
  padding: 0;
  /* 移除padding */
  margin: 0;
  /* 移除margin */
}

li {
  position: relative;
  /* 设置定位 */
  margin-bottom: 20px;
}

li:after {
  content: "";
  /* 使用:after伪元素添加内容 */
  position: absolute;
  /* 绝对定位 */
  left: 0;
  /* 从左边开始 */
  right: 0;
  /* 至右边结束 */
  bottom: 0;
  /* 定位至底部 */
  //border-bottom: 1px solid #ccc; /* 添加直线 */
}

.list-pagination {
  margin-left: 20px;
  margin-right: 20px;
  display: flex;
  justify-content: flex-end;
  margin: 1px 0 0px 0;
  background: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/components/sigen/notification/index.vue